import React from 'react';
import './SrfIcons.css';

interface SrfIconsProps {
    fbiSrf: string;
    stateSrf: string;
    stateCaseType: string;
}

const SrfIcons: React.FC<SrfIconsProps> = ({ fbiSrf, stateSrf, stateCaseType }) => {
    const getFbiIcon = () => {
        switch (fbiSrf) {
            case 'R':
                return <div className="srf-icon fbi-hit" title="FBI Hit (Record)">R</div>;
            case 'Y':
                return <div className="srf-icon fbi-possible" title="FBI Possible Hit">Y</div>;
            case 'G':
                return <div className="srf-icon fbi-no-hit" title="FBI No Record">G</div>;
            default:
                return null;
        }
    };

    const getStateIcon = () => {
        // No SRF yet (submission still pending) - show nothing rather than
        // implying a non-ident result.
        if (!stateSrf) {
            return null;
        }
        if (stateSrf !== 'I') {
            return <div className="srf-icon state-no-hit" title="State Non-Ident">N</div>;
        } else if (stateCaseType?.toUpperCase() === 'CRIMINAL') {
            return <div className="srf-icon state-criminal" title="State Criminal Hit">I</div>;
        } else {
            return <div className="srf-icon state-civil" title="State Civil Hit">I</div>;
        }
    };

    return (
        <div className="srf-icons-container">
            {getFbiIcon()}
            {getStateIcon()}
        </div>
    );
};

export default SrfIcons;
